import { ColumnModal } from "@/components";
import { useTranslate } from "@/providers/context";
import { useNavigate } from "react-router-dom";

export const UpSell = () => {
  const navigate = useNavigate();
  const { translate } = useTranslate();
  return (
    <ColumnModal
      cols={3}
      title={translate("Upgrade Your Plan")}
      primaryText={translate("Go to Profile")}
      onConfirm={() => navigate("/profile")}
      onCancel={() => navigate(-1)}
      hideTrigger
      open
    >
      <div className="p1-regular text-item-primary my-6 px-6">
        {translate("Sorry, you do not have access to this video.")} <br />
        {translate("Go to")}{" "}
        <span className="p1-semibold">
          {translate("Profile")} {">"} {translate("Manage My Subscription")}
        </span>{" "}
        {translate("to upgrade your plan and gain access.")}
      </div>
    </ColumnModal>
  );
};
